// TODO should be moved to particles
import React from 'react'
import styled from 'particles/themes/styled'
import { theme } from 'theme'
import Text from 'particles/Text'

type loaderSize = 's' | 'm' | 'l'
interface LoaderProps {
    progressBackgroundColor?: string
    progressBarColor?: string
    size?: loaderSize
    loadingText?: string
    className?: string
}

const spinnerSize: { [key: string]: number } = {
    s: 16,
    m: 20,
    l: 24,
}

const Spinner = styled.div<LoaderProps>`
    border: ${({ size }): string => (size ? spinnerSize[size] * 0.13 + 'px' : '16px')} solid
        ${({ progressBackgroundColor }): string =>
            progressBackgroundColor ? progressBackgroundColor : 'rgba(115, 115, 115, 0.2)'};
    border-top: ${({ size }): string => (size ? spinnerSize[size] * 0.13 + 'px' : '16px')} solid
        ${({ progressBarColor }): string => (progressBarColor ? progressBarColor : theme.newColors.neutral500)};
    border-radius: 50%;
    width: ${({ size }): string => (size ? spinnerSize[size] + 'px' : '100px')};
    height: ${({ size }): string => (size ? spinnerSize[size] + 'px' : '100px')};
    animation: spin 2s linear infinite;

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }
        100% {
            transform: rotate(360deg);
        }
    }
`

const LoadingText = styled(Text)`
    margin-left: 8px;
`

/**
 * @deprecated Please use particles/Loader
 */
const Loader: React.FC<LoaderProps> = ({ loadingText, ...props }) => {
    return (
        <>
            <Spinner {...props} />
            {loadingText && (
                <LoadingText scale={props.size === 'l' ? 'bodyM500' : 'bodyS500'} color="primary">
                    {loadingText}
                </LoadingText>
            )}
        </>
    )
}

export default Loader
